import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Coffee, Library, User } from "lucide-react";

const items = [
  { to: "/", label: "Home", icon: Home, testid: "nav-home", end: true },
  { to: "/brew-guide", label: "Brew", icon: Coffee, testid: "nav-brew" },
  { to: "/recipes", label: "Recipes", icon: Library, testid: "nav-recipes" },
  { to: "/account", label: "Account", icon: User, testid: "nav-account" },
];

export default function BottomNav() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 h-16 sm:h-20 bg-[#D8C3A5]/95 backdrop-blur-lg border-t border-[#1F2A44]/15 safe-bottom"
      data-testid="bottom-nav"
    >
      <div className="max-w-lg mx-auto h-full grid grid-cols-4">
        {items.map(({ to, label, icon: Icon, testid, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className="flex flex-col items-center justify-center gap-1 h-full"
          >
            {({ isActive }) => (
              <>
                <Icon size={22} className={isActive ? "text-[#F57C00]" : "text-[#1F2A44]/65"} />
                <span className={`text-xs font-semibold ${isActive ? "text-[#1F2A44]" : "text-[#1F2A44]/65"}`}>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
